import React from 'react';

interface LandingFooterProps {
  onSignInClick: () => void;
  brandPrimary: string;
  brandDark: string;
}

export const LandingFooter: React.FC<LandingFooterProps> = ({
  onSignInClick,
  brandPrimary,
  brandDark,
}) => {
  return (
    <footer
      style={{
        padding: '6rem 5% 4rem',
        background: brandDark,
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginTop: '4rem',
        borderRadius: '40px 40px 0 0',
      }}
    >
      <div
        style={{
          background: `linear-gradient(135deg, ${brandPrimary}, #4F46E5)`,
          padding: '4rem 5%',
          borderRadius: '32px',
          marginBottom: '6rem',
          width: '100%',
          maxWidth: '1000px',
          boxShadow: '0 20px 40px rgba(124,58,237,0.3)',
        }}
      >
        <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 800, margin: '0 0 1.5rem 0' }}>
          Ready to take control?
        </h2>
        <p style={{ fontSize: '1.2rem', opacity: 0.9, marginBottom: '2.5rem', fontWeight: 500 }}>
          Join thousands of families, creative studios, and businesses managing their media on FileSharez.
        </p>
        <button
          onClick={onSignInClick}
          style={{
            background: 'white',
            color: brandPrimary,
            padding: '1.2rem 3rem',
            borderRadius: '40px',
            border: 'none',
            fontWeight: 800,
            fontSize: '1.2rem',
            cursor: 'pointer',
          }}
        >
          Get Started Free
        </button>
      </div>

      <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center', fontWeight: 600, color: '#9CA3AF', marginBottom: '3rem' }}>
        <span style={{ cursor: 'pointer' }}>Privacy Policy</span>
        <span style={{ cursor: 'pointer' }}>Terms of Service</span>
      </div>
      <div style={{ color: '#6B7280', fontSize: '0.9rem', fontWeight: 500 }}>
        © {new Date().getFullYear()} FileSharez. All rights reserved. Built with ❤️.
      </div>
    </footer>
  );
};
